import { useUserContext } from '../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useMutation, useQuery } from 'react-query'
import {
  tsGetAnimal,
  tsGetAnimalsInContainer,
  tsGetSampleRun,
  tsGetScreenCollection
} from '../../Typescript/API_Response'
import { AxiosResponse } from 'axios'
import AnimalService from '../PHP/APIs/AnimalService'
import { useNavigate } from 'react-router-dom'

export function useGetAnimal(UAI: string | undefined) {
  const { whoAmI } = useUserContext()
  const { setError, setMessage } = useMessagePopupContext()
  return useQuery<tsGetAnimal, AxiosResponse>(
    ['AnimalService', 'getAnimal', UAI],
    () => AnimalService.getAnimal(whoAmI!, UAI!),
    {
      onSuccess: (data) => {
        if (!data?.UAI) {
          setMessage({
            subject: 'Error getting AddAnimal',
            message: (data as any)?.message,
            severity: 'warning'
          })
        }
      },
      onError: (err) => setError(err),
      enabled: !!whoAmI && !!UAI
    }
  )
}

export function useFetchAnimalsInContainer(
  sampleRun: tsGetSampleRun | undefined,
  collection: tsGetScreenCollection | undefined,
  containerRef: any
) {
  const { whoAmI } = useUserContext()
  const navigate = useNavigate()
  const { setError, setMessage } = useMessagePopupContext()
  return useMutation<
    tsGetAnimalsInContainer,
    AxiosResponse,
    number,
    () => void
  >(
    ['AnimalService', 'getAnimalsInContainer'],
    (container_id) =>
      AnimalService.getAnimalsInContainer(whoAmI!, container_id),
    {
      onSuccess: (data) => {
        if (data?.container) {
          const addType =
            sampleRun?.runInfo.RunType === '550' || sampleRun?.runInfo.RunType === '560' || sampleRun?.runInfo.RunType === '570' ? 'storage' : 'animal '
          navigate('/stuart/sample/add/' + addType, {
            state: {
              container: data as tsGetAnimalsInContainer,
              sampleRun: sampleRun,
              collection: collection
            }
          })
        } else if (data?.animals) {
          setMessage({
            subject: 'Error',
            severity: 'warning',
            message: 'Container could not be found or contains no animals'
          })
          containerRef?.current?.focus?.()
        } else {
          setMessage({
            subject: 'Error',
            severity: 'error',
            message: 'An unknown error occurred loading container'
          })
        }
      },
      onError: (err) => setError(err)
    }
  )
}
